import * as React from 'react'

import { getClient } from './client'
import { stripDecorationFromScreenEventName } from './utils'

// A handy hook that uses the component's mounting and unmounting to track a screen event
export function useTrackComponentAsScreen(screenId: string) {
  React.useEffect(() => {
    const analyticsClient = getClient()
    if (analyticsClient == null) return
    let previousScreen: string | null
    if (analyticsClient.currentScreen != null) {
      previousScreen = stripDecorationFromScreenEventName(
        analyticsClient.currentScreen.name,
        analyticsClient.appName,
      )
    }
    analyticsClient.trackScreen({
      name: screenId,
    })

    return () => {
      if (previousScreen == null) return
      analyticsClient.trackScreen({ name: previousScreen })
    }
  }, [screenId])
}
